import createReducer from '../../../data/shared/createReducer';
import { REQUEST_FORGOT_PASSWORD, FORGOT_PASSWORD_SUCCESS, FORGOT_PASSWORD_FAILURE, RESET_FORGOT_PASSWORD } from '../constants/action_types';

const initialState = {
    isLoading: false,
    submitted: false,
    success: false,
    email: null
};

const requestForgotPassword = (state, action) => ({
    ...state,
    isLoading: true,
});

const forgotPasswordSuccess = (state, action) => ({
    ...state,
    isLoading: false,
    submitted: true,
    success: true,
    email: action.data.email
});

const forgotPasswordFailure = (state, action) => ({
    ...state,
    isLoading: false,
    submitted: true,
    success: false
});

const resetForgotPassword = (state, action) => ({
    ...initialState
});

const forgotPasswordReducer = createReducer(initialState, {
    [REQUEST_FORGOT_PASSWORD]: requestForgotPassword,
    [FORGOT_PASSWORD_SUCCESS]: forgotPasswordSuccess,
    [FORGOT_PASSWORD_FAILURE]: forgotPasswordFailure,
    [RESET_FORGOT_PASSWORD]: resetForgotPassword
});

export default forgotPasswordReducer;
